import AbstractTask from 'services/common/task-runner/abstract-task';

/**
 * Retrieves user specific promotions.
 *
 * @class PollUserPromotionsTask
 * @extends AbstractTask
 * @memberof Mojito.Services.Promotions
 */
class PollUserPromotionsTask extends AbstractTask {
    constructor(service, onSuccess, onFailed) {
        super();
        this.service = service;
        this.onSuccess = onSuccess;
        this.onFailed = onFailed;
    }

    execute(callback) {
        if (!this.service || !this.service.getPromotions) {
            return;
        }

        const withFinallyCallback = action => response => {
            action(response);
            callback();
        };
        this.service
            .getPromotions()
            .then(withFinallyCallback(this.onSuccess))
            .catch(withFinallyCallback(this.onFailed));
    }
}

export default PollUserPromotionsTask;
